








































































import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class BonusSmallIcon extends Vue {
  @Prop({ default: '76' }) readonly width?: string;
  @Prop({ default: '99' }) readonly height?: string;
}
